<template>
    <div class="row d-flex flex-row mb-2">
      <div class="col col-auto" style="width: 300px">
        <input type="text" class="form-control" :value="ExpenseType.Name" @input="$emit('onchange', ExpenseType)">
      </div>
      <div class="col col-auto" style="width: 300px">
        <v-select
          v-model="ExpenseType.ExpenseGroupId"
          :options="ExpenseGroups"
          :taggable="true"
          label="Name"
          :reduce="item => item.Id"
          style="min-width: 200px"

        >
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              :required="!ExpenseType.ExpenseGroupId"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </div>
      <div class="col col-auto">
        <button type="button" class="btn btn-outline-warning" @click.prevent="$emit('removeExpenseType', ExpenseType)">Удалить</button>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    ExpenseGroups: {
      default() {
        return [];
      },
      type: Array,
    },
    ExpenseType: {
      default() {
        return {
          Name: '',
          ExpenseGroupId: null,
        };
      },
      type: Object,
    },
  },
  watch: {
    'ExpenseType.ExpenseGroupId': function () {
      this.$emit('onchange', this.ExpenseType);
    },
  },
};
</script>
